<app-admin-header></app-admin-header>
<article class="d-flex flex-column">
    <app-header></app-header>
    <app-unauthorized-error
        class="d-block h-100 pt-8 pb-4"
        *ngIf="errorCode === ErrorCode.Error401 || errorCode === ErrorCode.Error403"
        [showContent]="errorCode === ErrorCode.Error403"
        [errorCode]="errorCode"
        [nextURL]="nextURL"
        [isStudent]="isStudent"
        [learningObjects]="learningObjects"
        [subjects]="subjects"
    ></app-unauthorized-error>
    <app-not-found-error
        [learningObjects]="learningObjects"
        [subjects]="subjects"
        class="d-block h-100 pt-8 pb-4"
        *ngIf="errorCode === ErrorCode.Error404"
    ></app-not-found-error>
    <app-internal-server-error
        class="d-block h-100 pt-8 pb-4"
        [subjects]="subjects"
        *ngIf="errorCode === ErrorCode.Error500"
    ></app-internal-server-error>
    <app-footer></app-footer>
    <app-simplified-footer></app-simplified-footer>
</article>
